export const SET_WINDOW_WIDTH = "helpers/SET_WINDOW_WIDTH";
export const SET_SEARCH_OPENED = "helpers/SET_SEARCH_OPENED";
export const SET_SEARCH_HIDDEN = "helpers/SET_SEARCH_HIDDEN";
export const SET_SIDEBAR_OPENED = "helpers/SET_SIDEBAR_OPENED";
export const SET_SIDEBAR_HIDDEN = "helpers/SET_SIDEBAR_HIDDEN";
export const SET_MOBILE = "helpers/SET_MOBILE";
